<!--
  (compare w/ src/pages/associate/Dashboard/Index.vue
              src/pages/associate/Dashboard/Integrated.vue
              src/pages/associate/Dashboard/NonIntegrated.vue

  Q.  Integrated?  What does that mean?!
  A.
      "integrated" means user/customer who we have "integrated with an external CRM system with".
      Like Netsuite or Salesforce!  Meaning, we can show sales/customer data on screen,
      because we have a means of pulling their internal data.

      (backend-wise, see api.models.Plan's 'has_sales' field, and the
       'is_integrated' method of api.models.Institution)

      MAIN DIFFERENCES:

        - INTEGRATED ACCOUNTS/CUSTOMERS:

          - three column dashboard with Profile + Notification | Team | Sales

        - NON INTEGRATED ACCOUNTS/CUSTOMERS:

          - managers:  two-column dashboard; left side is a Notification panel;
             (admins)  right side is a wider list of all the manager's team members

          - stylists:  two-column dashboard; left side is a Notification panel;
                       right side is a column of VIEWS and CLICKS on emails & links
                       the stylist might have shared with their customers!
-->
<template>
  <main-layout wide>
    <div
      class="dashboard__grid"
      :class="{integrated: isIntegrated}"
    >
      <div
        class="col-left"
        :class="{integrated: isIntegrated}"
      >
        <UserCardContainer title="Admin" />
        <NotificationsContainer :readonly="true" />
      </div>

      <div>
        <TeamContainer />
      </div>

      <div v-if="isIntegrated">
        <SalesContainer />
      </div>
    </div>
  </main-layout>
</template>

<script>
import UserCardContainer from '@/components/Widgets/UserCardContainer';
import NotificationsContainer from '@/components/Widgets/NotificationsContainer';
import TeamContainer from '@/components/Widgets/TeamContainer';
import integrable from '@/components/mixins/integrable';
import SalesContainer from '@/components/Widgets/SalesContainer';

export default {
  components: {
    UserCardContainer,
    NotificationsContainer,
    TeamContainer,
    SalesContainer,
  },
  mixins: [integrable],
};
</script>

<style lang="scss" scoped>
.dashboard__grid{
  display: grid;
  gap: 0 20px;
  grid-template-columns: minmax(200px, 265px)  minmax(492px, 1fr);

  &.integrated{
    grid-template-columns: 1fr 210px;
    @media screen and (min-width: map-get($breakpoints,'lg')){
      grid-template-columns: minmax(200px, 270px) minmax(545px, 1fr) minmax(209px, 310px);
    }
  }
}
.col-left.integrated{
  display: none;
  @media screen and (min-width: map-get($breakpoints,'lg')){
    display: block;
  }
}
</style>
